import React from 'react';
import {withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {Button, Switch, Tooltip} from 'antd';
import {openNotice, config, objectSerial} from 'Utils';
import {specialLineDetail, getPro4} from '../../service/order';
import moment from 'moment';

class SpecialPriceQuery extends React.Component {
    constructor(props) {
        super(props);
        const channelData = window.sessionStorage.getItem('cur_channel') || '';
        this.state = {
            rows: [],
            total: 0,
            loading: false,
            searchObj: {
                specCode: '',
                proCode: '',
                batchQuery: false,
                p: 1,
                s: 10,
            },
            formKey: 0,
            channelCode: channelData.split('|')[1] || '',
            specCodeOptions: [{text: '全部', value: ''}],
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.exportChange = this.exportChange.bind(this);
    }

    componentDidMount() {
        this.loadSpecCodeOptions();
    }

    loadSpecCodeOptions() {
        const {channelCode} = this.state;
        getPro4({
            channelCode,
            
            p: 1,
            s: 9999,
        }).then(result => {
            if (result.status && result.code == 200) {
                const arr = [{text: '全部', value: ''}];
                (result.data || []).forEach(item => {
                    if (!item.specCode) {
                        return;
                    }
                    const label = item.projectName
                        ? `${item.specCode} - ${item.projectName}`
                        : item.specCode;
                    if (!arr.some(opt => opt.value === item.specCode)) {
                        arr.push({text: label, value: item.specCode});
                    }
                });
                this.setState({specCodeOptions: arr});
            }
        });
    }

    validateSearch() {
        const {specCode, proCode, batchQuery} = this.state.searchObj;
        if (!batchQuery && !specCode && !proCode) {
            openNotice('warning', '特价编码和物料编码至少填写一项');
            return false;
        }
        return true;
    }

    normalizeRows(data) {
        return (data || []).map((row, index) => ({
            ...row,
            id: row.id || row.rn || `${row.specCode || ''}_${row.proCode || ''}_${index}`,
        }));
    }

    fetchData() {
        if (!this.validateSearch()) {
            this.setState({loading: false});
            return;
        }
        const self = this;
        const {searchObj, channelCode} = this.state;
        specialLineDetail({
            specCode: searchObj.specCode,
            proCode: searchObj.proCode,
            batchQuery: searchObj.batchQuery,
            channelCode,
            p: searchObj.p,
            s: searchObj.s,
        }).then(result => {
            if (result.status && result.code == 200) {
                const rows = self.normalizeRows(result.data);
                self.setState({
                    rows,
                    total: result.total || rows.length,
                    loading: false,
                });
            } else {
                openNotice('error', result.message || '查询失败');
                self.setState({rows: [], total: 0, loading: false});
            }
        }).catch(() => {
            openNotice('error', '查询失败');
            self.setState({loading: false});
        });
    }

    pageChange(page, pageSize) {
        const self = this;
        this.setState({
            searchObj: {...this.state.searchObj, p: page, s: pageSize},
            loading: true,
        }, () => self.fetchData());
    }

    advanceReset() {
        this.setState({
            searchObj: {
                specCode: '',
                proCode: '',
                batchQuery: false,
                p: 1,
                s: 10,
            },
            rows: [],
            total: 0,
            formKey: this.state.formKey + 1,
        });
    }

    advanceSubmit() {
        if (!this.validateSearch()) {
            return;
        }
        this.setState({
            searchObj: {...this.state.searchObj, p: 1},
            loading: true,
        }, () => this.fetchData());
    }

    setFilterParam(name, value) {
        const nextValue = typeof value === 'string' ? value.trim() : value;
        this.setState({searchObj: {...this.state.searchObj, [name]: nextValue}});
    }

    exportChange() {
        if (!this.validateSearch()) {
            return;
        }
        const {searchObj, channelCode} = this.state;
        const param = {
            specCode: searchObj.specCode,
            proCode: searchObj.proCode,
            batchQuery: searchObj.batchQuery,
            channelCode,
        };
        const url = `${config.server}/api/v1/dms/tgOrder/specialLineDetailExp?${objectSerial(param)}`;
        window.open(url);
    }

    nowrapCell(text) {
        if (text == null || text === '') {
            return '';
        }
        return <span style={{whiteSpace: 'nowrap'}}>{text}</span>;
    }

    render() {
        const {rows, total, loading, searchObj, specCodeOptions, formKey} = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'specCode',
                    label: '特价编码',
                    text: '选择特价编码',
                    type: 'select',
                    options: specCodeOptions,
                    multiple: false,
                    showSearch: true,
                    defaultValue: searchObj.specCode || '',
                },
                {
                    name: 'proCode',
                    label: '物料编码',
                    text: '输入物料编码',
                    type: 'default',
                    defaultValue: searchObj.proCode,
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam,
        };
        const tableViewProps = {    
            loading,
            rowKey: 'id',
            pageParam: {
                total,
                current: searchObj.p,
                pageSize: searchObj.s,
                onChange: this.pageChange,
            },
            columns: [
                {title: '特价编码', dataIndex: 'specCode', render: this.nowrapCell.bind(this),width: 100},
                {title: '购货单位', dataIndex: 'buyCompanyName', render: this.nowrapCell.bind(this),width: 100},
                {title: '物料编码', dataIndex: 'proCode', render: this.nowrapCell.bind(this),width: 100},
                {title: '物料描述', dataIndex: 'proDesc', render: this.nowrapCell.bind(this),width: 100},
                {title: '特价数量', dataIndex: 'count', render: this.nowrapCell.bind(this),width: 100},
                {title: '面价', dataIndex: 'listPrice', render: this.nowrapCell.bind(this),width: 80},
                {title: '合同价', dataIndex: 'price', render: this.nowrapCell.bind(this),width: 80},
                {title: '产品类别', dataIndex: 'categoryDesc', render: this.nowrapCell.bind(this),width: 100},
                {title: '类别编码', dataIndex: 'categoryCode', render: this.nowrapCell.bind(this),width: 100},
                {title: '合同下浮比例', dataIndex: 'lowerRate', render: this.nowrapCell.bind(this),width: 110},
                {title: '预计销量', dataIndex: 'amount', render: this.nowrapCell.bind(this),width: 100},
                {title: '剩余销量', dataIndex: 'remainingSales', render: this.nowrapCell.bind(this),width: 100},
                {title: '已开单数量', dataIndex: 'orderQty', render: this.nowrapCell.bind(this),width: 100},
                {title: '已开单金额', dataIndex: 'orderAmount', render: this.nowrapCell.bind(this),width: 100},
                {
                    title: '开始日期',
                    dataIndex: 'startDate',
                    render: text => this.nowrapCell(text ? moment(text).format('YYYY-MM-DD') : ''),
                    width: 100,
                },
                {
                    title: '结束日期',
                    dataIndex: 'endDate',
                    render: text => this.nowrapCell(text ? moment(text).format('YYYY-MM-DD') : ''),
                    width: 100,
                },
                {title: '项目名称', dataIndex: 'projectName', render: this.nowrapCell.bind(this),width: 100},
                {title: '承接业务员', dataIndex: 'userName', render: this.nowrapCell.bind(this),width: 100},
                {title: '终端单位', dataIndex: 'terminalName', render: this.nowrapCell.bind(this),width: 100},
                {title: '盘厂终端', dataIndex: 'zdCompany', render: this.nowrapCell.bind(this),width: 100},
            ],
            scroll: {x: 2000, y: false},
            rows,
        };

        return (
            <div className="dms-body">
                <DmsTab options={['特价查询']} defaultKey={0}/>
                <div className="advanceForm-box">
                    <div className="advanceForm-content">                        
                        <AdvanceFormNew key={formKey} {...advanceProps}/>
                        <div style={{marginBottom: 8}}>
                            <label style={{width: '300px'}}>批量查询：</label>
                            <Tooltip title="批量查询数据有一定延迟">
                                <Switch checked={searchObj.batchQuery}
                                        onChange={value => this.setFilterParam('batchQuery', value)}
                                        style={{width: '10px'}}/>
                            </Tooltip>
                        </div>
                    </div>
                </div>
                <div className="dms-table-box special-price-query-table">
                    <div className="dms-table-head" style={{padding: '8px 8px 8px 0'}}>
                        <span>{total}条明细</span>
                        <Button style={{position: 'absolute', right: 0, bottom: 8}} icon="export"
                                onClick={this.exportChange}>导出</Button>
                    </div>
                    <TableView {...tableViewProps}/>
                </div>
            </div>
        );
    }
}

export default withRouter(SpecialPriceQuery);



// WEBPACK FOOTER //
// ./src/routes/order/specialPriceQuery.js